import { Product } from "~/server/types/search";
import { clientRepo } from "~/server/apis/client_repo";

export type HomeOnecardRouteData = {
  brands: Product[];
};

export async function getHomeOnecardRouteData(): Promise<HomeOnecardRouteData> {
  const allBrands = await clientRepo.getProductSearch({ query: "" });

  const activeBrands =
    allBrands?.data?.[0]?.products?.filter(
      (product) => product.voucherProduct.status === "ACTIVE"
    ) || [];

  return {
    brands: activeBrands,
  };
}
